export const CRITICAL_WORKFLOW_PAIN_WINDOW_VITAL_NAME =
  'critical_workflow_pain_window';
export const DEFAULT_CRITICAL_WORKFLOW_PAIN_WINDOW_DURATION_MS = 4_000;
export const CRITICAL_WORKFLOW_PAIN_WINDOW_INSTRUMENTATION_VERSION = 2 as const;
export const CRITICAL_WORKFLOW_EXPLICIT_PAIN_WINDOW_INSTRUMENTATION_VERSION =
  3 as const;
// Ceiling for both fixed windows and explicit sessions. Longer intervals stop
// describing one interaction and dilute blockedPercentage.
export const MAX_PAIN_OBSERVATION_DURATION_MS = 60_000;
